import { useEffect } from 'react';

import { datadogRum } from '@datadog/browser-rum';
import { usePathname, useSegments } from 'expo-router';

const ROUTE_GROUP_SEGMENT = /^\(.+\)$/;

export const getDatadogRoutePath = (segments: string[]) => {
  const routeSegments = segments.filter(
    segment => Boolean(segment) && !ROUTE_GROUP_SEGMENT.test(segment) && segment !== 'index'
  );

  return routeSegments.length ? `/${routeSegments.join('/')}` : '/';
};

export const getDatadogConcreteRoutePath = (pathname?: string | null) => {
  const sanitizedPathname = pathname?.split(/[?#]/)[0]?.trim() ?? '';

  if (!sanitizedPathname || sanitizedPathname === '/') {
    return '/';
  }

  return sanitizedPathname.startsWith('/') ? sanitizedPathname : `/${sanitizedPathname}`;
};

export const getDatadogRouteName = (routePath: string) => (routePath === '/' ? 'Home' : routePath);

export const useRumRouteView = () => {
  const segments = useSegments();
  const pathname = usePathname();
  const routeSegmentsKey = segments.join('/');

  useEffect(() => {
    const routeSegments = routeSegmentsKey ? routeSegmentsKey.split('/') : [];
    const routeTemplate = getDatadogRoutePath(routeSegments);
    const routePath = getDatadogConcreteRoutePath(pathname);

    datadogRum.startView({
      name: getDatadogRouteName(routePath),
      context: {
        routePath,
        routeTemplate,
        routeSegments,
      },
    });
  }, [pathname, routeSegmentsKey]);
};
